import { X } from 'lucide-react'

export function Modal({ title, children, onClose, width = '640px' }: {
  title: string
  children: React.ReactNode
  onClose: () => void
  width?: string
}) {
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="modal" role="dialog" aria-modal="true" aria-label={title} style={{ maxWidth: width }}>
        <header><h2>{title}</h2><button className="icon-button" onClick={onClose} aria-label="Fechar"><X size={20} /></button></header>
        {children}
      </section>
    </div>
  )
}
